module.exports = "/lucky-balls/img/colorBetting.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/colorBetting.png
// module id = 975
// module chunks = 0